// pairing-api.ts - client for the short-code pairing API.

export interface PairingCodeResponse {
  code: string;
  expiresIn: number;
}

export interface PairingStatus {
  status: string;
  roomId: string;
  publicKey: string;
  fingerprint: string;
  envelope?: string;
}

export async function createPairingCode(roomId: string, accessToken: string): Promise<PairingCodeResponse> {
  const resp = await fetch(`/api/v1/rooms/${roomId}/pairing-code`, {
    method: 'POST',
    headers: { 'X-Room-Access-Token': accessToken },
  });
  if (!resp.ok) throw new Error(`failed to create pairing code: ${resp.status}`);
  return resp.json();
}

export async function joinPairing(code: string, publicKey: string): Promise<void> {
  const resp = await fetch('/api/v1/pairing/join', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code, publicKey }),
  });
  if (!resp.ok) throw new Error(`failed to join pairing: ${resp.status}`);
}

export async function pollPairingStatus(code: string, accessToken: string): Promise<PairingStatus> {
  const resp = await fetch(`/api/v1/pairing/${code}/status`, {
    headers: { 'X-Room-Access-Token': accessToken },
  });
  if (!resp.ok) throw new Error(`failed to poll pairing status: ${resp.status}`);
  return resp.json();
}

export async function approvePairing(code: string, accessToken: string, envelope: string): Promise<void> {
  const resp = await fetch(`/api/v1/pairing/${code}/approve`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Room-Access-Token': accessToken,
    },
    body: JSON.stringify({ envelope }),
  });
  if (!resp.ok) throw new Error(`failed to approve pairing: ${resp.status}`);
}

export async function fetchPairingResult(code: string): Promise<{ roomId: string; envelope: string }> {
  const resp = await fetch(`/api/v1/pairing/join/${code}/result`);
  if (!resp.ok) throw new Error(`pairing not ready: ${resp.status}`);
  return resp.json();
}
